import { ChatNodeValue } from '@core';
import { Site, UnReadMessages } from '@type';

import { dateToUnix } from '../date';

export const groupDataByDate = <T extends { timestamp: string }>(
  dataCollection: T[]
): Record<string, T[]> => {
  return dataCollection.reduce((acc: Record<string, T[]>, data) => {
    const date = dateToUnix(data.timestamp.split('T')[0]);
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(data);

    return acc;
  }, {});
};

export const getTotalUnReadCount = (
  unReadMessages: UnReadMessages,
  sites: Site[]
) => {
  const sum = sites.reduce((acc, site) => {
    const siteData = unReadMessages[site.siteUuid];
    if (siteData) {
      acc += siteData.count;
    }
    return acc;
  }, 0);

  return sum;
};

export const getUnreadMessagesForSite = (chatNodes: {
  [key: string]: ChatNodeValue;
}) => {
  const groupedBySiteUUID = {} as UnReadMessages;
  Object.entries(chatNodes as { [key: string]: ChatNodeValue }).forEach(
    ([key, value]) => {
      const siteRef = `${value.siteUUID}`;
      if (!groupedBySiteUUID[siteRef]) {
        groupedBySiteUUID[siteRef] = { count: 0, keys: [] };
      }
      groupedBySiteUUID[siteRef].count += 1;
      groupedBySiteUUID[siteRef].keys.push(key);
    }
  );
  return groupedBySiteUUID;
};
